import { VideoCameraFrontOutlined } from "@mui/icons-material";
import { Link } from "@mui/material";
import { ItemProperty } from "src/components";

interface Props {
  videoUrl: string;
}

const FormSubmissionVideoUrlProperty = (props: Props) => {
  return (
    <ItemProperty labelIcon={<VideoCameraFrontOutlined />} label="Link to Video">
      <Link href={props.videoUrl} target="_blank" rel="noopener noreferrer">
        {props.videoUrl}
      </Link>
    </ItemProperty>
  );
};

export { FormSubmissionVideoUrlProperty };
